export const LOW_BALANCE_BET_ON_ALL_DIALOG = 'LowBalanceBetOnAllDialog';
